// /* eslint-disable */
import { usePreferences } from "@temp/@next/hooks";
import React from "react";
import { Link } from "react-router-dom";
import * as S from "./styles";

var generateDot = function generateDot(stepIndex, currentActiveStep) {
  if (stepIndex < currentActiveStep) {
    return React.createElement(S.Dot, {
      done: true
    }, stepIndex + 1);
  }

  if (stepIndex === currentActiveStep) {
    return React.createElement(S.Dot, {
      done: true,
      active: true
    }, stepIndex + 1);
  }

  return React.createElement(S.Dot, null, stepIndex + 1);
};

var generateLabel = function generateLabel(stepIndex, name, currentActiveStep) {
  return React.createElement(S.Label, {
    done: stepIndex <= currentActiveStep
  }, name);
};

var generateProgressBar = function generateProgressBar(index, currentActive, numberOfSteps) {
  // if (index !== numberOfSteps - 1) {
  return React.createElement(S.ProgressBar, {
    done: currentActive >= index
  }); // }
};

var generateSteps = function generateSteps(steps, currentActive, locale) {
  return steps === null || steps === void 0 ? void 0 : steps.map(function (step) {
    return React.createElement(S.Step, {
      key: step.index
    }, React.createElement(Link, {
      to: step.link
    }, generateDot(step.index, currentActive), generateLabel(step.index, step.name[locale], currentActive)), generateProgressBar(step.index, currentActive, steps.length));
  });
};
/**
 * Progress bar showing current step of checkout process.
 */


var CheckoutProgressBar = function CheckoutProgressBar(_ref) {
  var steps = _ref.steps,
      activeStep = _ref.activeStep;

  var _usePreferences = usePreferences(),
      locale = _usePreferences.preferences.locale;

  return React.createElement(S.Wrapper, null, generateSteps(steps, activeStep, locale));
};

export { CheckoutProgressBar };